export enum CampaignType {
  POWER_DIALER = "POWER_DIALER",
  SEQUENCE = "SEQUENCE",
}
